import { Injectable, inject } from '@angular/core';

import { AccessRole } from '../../models/access.token.models/access.role';
import { AccessControlService } from './access-control.srvice';

@Injectable({
  providedIn: 'root',
})
export class BmAuthGuard {
  accessControl = inject(AccessControlService);

  accessRole: AccessRole = new AccessRole();

  canActivate(): boolean {
    if (this.accessControl.hasAccess(this.accessRole.USER_ROLE_BM)) {
      return true;
    } else {
      this.accessControl.handleAccessDenied();
      return false;
    }
  }
}
